import React from "react";
import OptionCard from "./OptionCard";

const AudioChatView = ({ series }: { series: any }) => (
  <div className="space-y-4">
    <audio controls src={series.question.audioUrl} className="w-full rounded" />
    <div className="flex gap-3 overflow-x-auto pb-2">
      {series.options.map((opt: any) => (
        <OptionCard
          key={opt.id}
          option={opt}
          isCorrect={series.answer.includes(opt.id)}
        />
      ))}
    </div>
  </div>
);

export default AudioChatView;
